import React from 'react';
import OfferFigure from './offer_figure';
import OfferDescription from './offer_description';
import { T } from '../../../../../../common/locale/translate';

export default class OfferItem extends React.Component {
  render() {
    const { special_offer } = this.props;
    const offerTypeMapping = {
      A: T('holiday'),
      S: T('hotel_only')
    };

    const offerType = offerTypeMapping[special_offer.offer_type] || '';

    return (
      <a
        href={special_offer.subject.description_link}
        className="offer-item"
        title={`${offerType}: ${special_offer.subject.name}`}
      >
        <OfferFigure special_offer={special_offer} offerType={offerType} />
        <OfferDescription special_offer={special_offer} />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/offer_item.jsx